import { render, staticRenderFns } from "./PostSearch.vue?vue&type=template&id=69378eb8&scoped=true"
import script from "./PostSearch.vue?vue&type=script&lang=js"
export * from "./PostSearch.vue?vue&type=script&lang=js"
import style0 from "./PostSearch.vue?vue&type=style&index=0&id=69378eb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69378eb8",
  null
  
)

export default component.exports